/* eslint-disable */
import { useShallow } from 'zustand/react/shallow';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	LineElement,
	PointElement,
	Filler,
} from 'chart.js';
import { connect } from 'react-redux';
import { analyticsAction } from '@/Actions';
import { useAnalysisStore } from './AssetAnalysisStore';
import HeaderSection from './HeaderSection';
import SummaryCards from './SummaryCards';
import { useEffect, useState, useMemo } from 'react';
import stateChangeService from './Services/stateChangeService';
import { BackdropLoader } from '../Loaders';
import { Bar } from 'react-chartjs-2';
import { Button } from '@/Components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	LineElement,
	PointElement,
	Filler
);

function AssetAnalysisPage(
	{
		// date = new Date().toLocaleDateString('en-US', {
		// 	month: 'long',
		// 	day: 'numeric',
		// 	year: 'numeric',
		// }),
		// fetchBrands,
		// products,
		// fetchProducts,
	}
) {
	const {
		activeAnalysisTab,
		activeConfigType,
		isLoading,
		analysisChartData,
		activeTimeRangeDropdown,
		activeAssetWiseDropdown,
		activeGeographyWiseDropdown,
		setGlobalProductList,
	} = useAnalysisStore(
		useShallow((state) => ({
			activeAnalysisTab: state.activeAnalysisTab,
			isLoading: state.loading,
			activeConfigType: state.activeConfigType,
			analysisChartData: state.analysisChartData,
			activeTimeRangeDropdown: state.activeTimeRangeDropdown,
			activeAssetWiseDropdown: state.activeAssetWiseDropdown,
			setGlobalProductList: state.setGlobalProductList,
			activeGeographyWiseDropdown: state.activeGeographyWiseDropdown,
		}))
	);

	const [currentPage, setCurrentPage] = useState(0);
	const [itemsPerPage] = useState(31); // Show 31 data points at a time

	useEffect(() => {
		setCurrentPage(0);
	}, [analysisChartData]);

	console.log('analysisChartData', analysisChartData);
	const paginatedChartData = useMemo(() => {
		if (!analysisChartData?.chartData?.labels?.length)
			return analysisChartData;

		const originalData = analysisChartData.chartData;

		// If data is small enough, return as is
		if (originalData.labels.length <= itemsPerPage) {
			return analysisChartData;
		}

		// Calculate pagination
		const startIndex = currentPage * itemsPerPage;
		const endIndex = Math.min(
			startIndex + itemsPerPage,
			originalData.labels.length
		);

		// Create paginated version
		const paginatedData = {
			...analysisChartData,
			chartData: {
				labels: originalData.labels.slice(startIndex, endIndex),
				labelIds:
					originalData.labelIds?.slice(startIndex, endIndex) || [],
				// Use the 'dataset' property from the original data
				dataset: Array.isArray(originalData.dataset)
					? originalData.dataset.map((dataset) => ({
							...dataset,
							data:
								dataset.data?.slice(startIndex, endIndex) || [],
					  }))
					: [],
			},
		};

		return paginatedData;
	}, [analysisChartData, currentPage, itemsPerPage]);

	useEffect(() => {}, []);

	useEffect(() => {
		const unSubs = stateChangeService.initializeStateChangeListeners();
		return unSubs;
	}, []);

	// useEffect(() => {
	// 	setGlobalProductList(products);
	// }, [products]);

	// Add a useEffect to reset pagination when chart data changes
	useEffect(() => {
		setCurrentPage(0);
	}, [analysisChartData?.chartData?.labels]);

	function buildXAxisLabel(
		configType,
		timeDropdown,
		assetWiseDropdown,
		geographyDropdown
	) {
		if (configType === 'time') {
			switch (timeDropdown) {
				case 'year':
					return 'Months in Year';
				case 'quarter':
					return 'Weeks in Quarter';
				case 'month':
					return 'Days in Month';
				default:
					return 'Time Period';
			}
		} else if (configType === 'assetGroupWise') {
			switch (assetWiseDropdown) {
				case 'assetCategory':
					return 'Categories';
				case 'assetType':
					return 'Asset Types';
				default:
					return 'Asset Group';
			}
		} else if (configType === 'geography') {
			switch (geographyDropdown) {
				case 'brand':
					return 'Regions';
				case 'region':
					return 'Cities';
				case 'city':
					return 'Stores';
				default:
					return 'Geography';
			}
		}
		return 'Data Points';
	}

	const renderContent = () => {
		if (activeAnalysisTab === 'quantitative') {
			return (
				<>
					<HeaderSection />
					<div className='px-2 flex flex-col flex-1 overflow-hidden'>
						<div className='px-6'>
							<SummaryCards />
						</div>
						<div className='rounded-lg flex-1 flex flex-col justify-between border border-gray-200 overflow-hidden'>
							<div className='flex-1 flex flex-col overflow-hidden relative'>
								{analysisChartData?.chartData?.labels?.length >
									itemsPerPage && (
									<div className='flex  justify-between w-1/4 absolute top-1 right-1 rounded-lg items-center py-3 px-2  border border-yellow-400 bg-gray-50'>
										{currentPage > 0 ? (
											<Button
												variant='outline'
												size='sm'
												onClick={() =>
													setCurrentPage((prev) =>
														Math.max(0, prev - 1)
													)
												}
												className='flex flex-1 items-center gap-1 bg-white shadow-sm'
											>
												<ChevronLeft size={16} />{' '}
												Previous
											</Button>
										) : (
											<div className='flex-1'></div> // Empty space placeholder when button is hidden
										)}

										<span className='text-xs flex-1 text-center font-medium text-gray-700'>
											Page {currentPage + 1} of{' '}
											{Math.ceil(
												analysisChartData.chartData
													.labels.length /
													itemsPerPage
											)}
										</span>

										{currentPage <
										Math.ceil(
											analysisChartData.chartData.labels
												.length / itemsPerPage
										) -
											1 ? (
											<Button
												variant='outline'
												size='sm'
												onClick={() =>
													setCurrentPage((prev) =>
														Math.min(
															Math.ceil(
																analysisChartData
																	.chartData
																	.labels
																	.length /
																	itemsPerPage
															) - 1,
															prev + 1
														)
													)
												}
												className='flex flex-1 items-center gap-1 bg-white shadow-sm'
											>
												Next <ChevronRight size={16} />
											</Button>
										) : (
											<div className='flex-1'></div> // Empty space placeholder when button is hidden
										)}
									</div>
								)}
								<div className='w-full flex-1 overflow-hidden'>
									<Bar
										data={{
											labels: paginatedChartData
												?.chartData?.labels,
											datasets:
												paginatedChartData?.chartData
													?.datasets ||
												paginatedChartData?.chartData
													?.dataset ||
												[],
										}}
										options={{
											responsive: true,
											maintainAspectRatio: false,
											scales: {
												x: {
													stacked: true,
													grid: {
														display: false,
													},
													title: {
														display: true,
														text: buildXAxisLabel(
															activeConfigType,
															activeTimeRangeDropdown,
															activeAssetWiseDropdown,
															activeGeographyWiseDropdown
														),
														font: {
															size: 12,
															weight: 'bold',
														},
													},
												},
												y: {
													stacked: true,
													grid: {
														display: true,
													},
													title: {
														display: true,
														text: 'Asset Count',
														font: {
															size: 12,
															weight: 'bold',
														},
													},
												},
											},
											plugins: {
												datalabels: {
													align: 'start',
													padding: '0',
													anchor: 'center',
													maxRotation: 0,
													rotation: 270,
													// formatter: dataLabelFormatter,
													// display: showDataLabels,
													clamp: false,
													color: '#000',
													font: {
														weight: '400',
														size: 9,
													},
												},
												title: {
													display: true,
													text: 'Asset Count',
													font: {
														color: 'black',
														size: 16,
													},
												},
											},
										}}
									/>
								</div>
								{/* Add pagination controls AFTER the chart with better visibility */}
							</div>
						</div>
					</div>
				</>
			);
		} else {
			return <></>;
		}
	};

	return (
		<div className=' h-[calc(100vh-64px)] flex flex-col p-0.5'>
			<BackdropLoader showProgress isLoading={isLoading} />
			{renderContent()}
		</div>
	);
}

export default connect(null, {
	setDateFilter: analyticsAction.setDateFilterTodayDate,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	applyFilters: analyticsAction.applyFilters,
})(AssetAnalysisPage);
